// extracted by mini-css-extract-plugin
export default {"imagesWrapper":"images_imagesWrapper__6LLNv"};